import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls, useRelations } from '@hooks/usePaginationRule'

import type { PaginationRuleModel } from '@models/types'

const PaginationRule = (props: { paginationRule: Partial<PaginationRuleModel> }) => {
  const { paginationRule } = props
  const { default: paginationRuleDefault, title } = paginationRule

  const { editPaginationRuleUrl } = generateUrls(paginationRule)

  const paginationRuleRelations = useRelations(paginationRule)
  const { brand } = paginationRuleRelations

  return (
    <DashboardModuleListItem
      href={editPaginationRuleUrl}
      secondaryText={brand.title}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {paginationRuleDefault ? 'Default' : null}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default PaginationRule
